module.exports = __webpack_public_path__ + "media/images/location_on-68d05131b75af50366ed8a5f6265f946.svg";